import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import './styles.scss'
import inchatActions from 'redux/inchat/actions'
import Message from './Message'
import { lang } from 'utils/helpers'
import ScrollableContent from 'components/ScrollableContent'
import PinnedMessages from './PinnedMessages'

const ChatMessages = ({ conversationId, isThread, operatorId }) => {
  const dispatch = useDispatch()
  const { inchat } = useSelector(store => store)
  const conversation = inchat.conversations[conversationId] || {}
  const chat = conversation?.chat || {}

  useEffect(() => {
    if (conversationId) {
      dispatch(inchatActions.getConversationMessages({ conversationId, page: 1 }))
    }
  }, [conversationId])

  const getMessages = async () => {
    if (chat?.isLoadingMessages) return
    if (!chat?.messages) return
    if (chat?.allMessagesGetting) return
    dispatch(inchatActions.getConversationMessages({ conversationId, page: chat?.page + 1 }))
  }

  return (
    <div className='inchat-chat-messages'>
      <PinnedMessages
        conversationId={conversationId}
      />
      <ScrollableContent onYReachEnd={getMessages} goToTop>
        <div className='inchat-chat-messages__messages'>
          {chat?.messages?.map((message, index) => {
            return (
              <Message
                key={index}
                message={message}
                operatorId={operatorId}
              />
            )
          })}
          {chat?.isLoadingMessages ?
            <p className='loading-info'>{`${lang('dashboard_loading-messages')}...`}</p>
            : null}
          {/* {chat?.allMessagesGetting ?
            <p className='inchat-chat-messages__text inchat-chat-messages__text--info'>
              {lang('dashboard_no-more-messages')}
            </p>
            : null} */}
        </div>
      </ScrollableContent>
    </div>
  )
}

export default ChatMessages
